<div class="h-full w-full">
    <div class="border-2 border-black w-full h-full" [id]="mapId"></div>
</div>